import React, { useState } from 'react';
import { FaChevronDown } from '@react-icons/all-files/fa/FaChevronDown';
import { FaChevronUp } from '@react-icons/all-files/fa/FaChevronUp';
import SideBarBranch from './SideBarBranch';
import SideBarTreehouses from './SideBarTreehouses';

function SideBarAccordian(props) {
  const [arrow, setArrow] = useState(true);

  const handleClick = () => {
    setArrow(!arrow);
  }


  return (
    <div className="accordian-col branches hide-on-toggle">
      <div className='accordian-head' onClick={handleClick}>
        {props?.type == "branch" ? "Branches" : "Treehouses"} : <span className='dropdown-ic'>{arrow ? <FaChevronDown /> : <FaChevronUp />}</span>
      </div>
      {props?.type == "branch" && arrow &&
        <SideBarBranch {...props} onBranchClick={props?.branchClick} setShowModal={props?.setShowModal} />
      }

      {props?.type == "treehouses" && arrow &&
        <SideBarTreehouses setShowModal={props.setShowModal} />
      }
    </div>
  );
}

export default SideBarAccordian;
